
import 'ol/ol.css';
import apply from 'ol-mapbox-style';
import Map from 'ol/Map';
import View from 'ol/View';
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import TileGrid from 'ol/tilegrid/TileGrid';
import { fromLonLat, get as projGet } from 'ol/proj'
import vectorlayers from './vectorlayers';


// let's load the style from project
// ! Edit maastotiedot.json and replace any 7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2 text (two intances) with your own api-key !
// ! Edit maastotiedot.json to apply your own styling to vector tile data !

// boundaries with raster background map
import style1 from './maastotiedot.json';
import style2 from './maastotiedot-taustakartalla.json';
import style3 from './maastotiedot-korkeusviivat.json';
import style3b from './maastotiedot-korkeusviivat-kaikki.json';
import style4 from './maastotiedot-vesistot.json';
import styleqa from './maastotiedot-qa.json';
import style3bqa from './maastotiedot-korkeusviivat-kaikki-qa.json';

proj4.defs("EPSG:4326", "+proj=longlat +datum=WGS84 +no_defs");
proj4.defs("EPSG:3067", "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
register(proj4);

// only boundaries
//import style from './maastotiedot.json';

const webLang = {
  fi: 'fi',
  fin: 'fi',
  'fi-FI': 'fi',
  sv: 'sv',
  swe: 'sv',
  'sv-FI': 'sv',
  en: 'en',
  eng: 'en'
},

  normalizedLang = {
    fi: 'fin',
    fin: 'fin',
    'fi-FI': 'fin',
    sv: 'swe',
    swe: 'swe',
    'sv-FI': 'swe',
    en: 'eng',
    eng: 'eng'
  };

const params = (new URL(document.location)).searchParams,
  lang = normalizedLang[params.get('lang')] || 'fin';


document.lang = webLang[lang];

const styles = {
  'tausta': style1,
  'ortokuva': style2,
  'maasto': style3,
  'maasto-korkeusviivat': style3b,
  'vesistot': style4,
  'qa': styleqa,
    'qa-maasto-korkeusviivat': style3bqa

},
  style = styles[params.get('style')] || style1;

const dontDeclutter = params.get('declutter') != undefined && params.get('declutter') === 'false'


const resolutions = [8192, 4096, 2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25];

const tileGrid = new TileGrid({
  extent: [-548576, 6291456, 1548576, 8388608],
  resolutions: resolutions,
  tileSize: [256, 256]
})

const projection = projGet('EPSG:3067');


const center = [24, 61];

// let's create the map
const map = new Map({
  target: 'map',
  view: new View({
    resolution: 256,
    resolutions: resolutions,
    center: fromLonLat(center, projection),
    projection: projection
  })
});

(async () => {

  const layers = await vectorlayers(projection, tileGrid, resolutions, style, {}, {}, dontDeclutter);

  layers.forEach(l => {
    map.addLayer(l);
  });

})();

window.map = map;